import React, { Component } from 'react';
import { FormGroup, InputGroup, Button, Intent, Card, Elevation } from '@blueprintjs/core';

export default class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      subject: '',
      message: '',
      status: null,
      loading: false
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ loading: true, status: null });

    const apiUrl = process.env.REACT_APP_API_URL || 'https://api.srofilter.com';

    fetch(`${apiUrl}/api/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        recipient: 'info@srofilter.com',
        name: this.state.name,
        senderEmail: this.state.email,
        subject: this.state.subject,
        message: this.state.message,
      }),
    })
      .then((res) => {
        this.setState({
          loading: false,
          status: 'SUCCESS',
          name: '',
          email: '',
          subject: '',
          message: '',
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
          status: 'SUCCESS',
          name: '',
          email: '',
          subject: '',
          message: '',
        });
      });
  };

  render() {
    return (
      <Card elevation={Elevation.ONE} className="p-4">
        <h5 className="mb-3 font-weight-bold" style={{ color: '#182026' }}>
          Contact SROFilter Support
        </h5>
        <p className="text-muted mb-3" style={{ fontSize: '0.85rem' }}>
          Have a question, need assistance, or want to report an issue? Fill in the form below and our team will get back to you at your email address.
        </p>

        {this.state.status === 'SUCCESS' && (
          <div className="alert alert-success py-2 mb-3" style={{ fontSize: '0.85rem' }}>
            Message successfully sent! Our support team will get back to you shortly.
          </div>
        )}

        <form onSubmit={this.handleSubmit}>
          <div className="row mb-3">
            <div className="col-md-6">
              <FormGroup label="Your Name" labelFor="contact-name">
                <InputGroup
                  id="contact-name"
                  required
                  placeholder="e.g. John Doe"
                  value={this.state.name}
                  onChange={(e) => this.setState({ name: e.target.value })}
                />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup label="Your Email" labelFor="contact-email">
                <InputGroup
                  id="contact-email"
                  type="email"
                  required
                  placeholder="e.g. admin@server.com"
                  value={this.state.email}
                  onChange={(e) => this.setState({ email: e.target.value })}
                />
              </FormGroup>
            </div>
          </div>

          <div className="mb-3">
            <FormGroup label="Subject" labelFor="contact-subject">
              <InputGroup
                id="contact-subject"
                required
                placeholder="e.g. SROFilter Gateway License Renewal"
                value={this.state.subject}
                onChange={(e) => this.setState({ subject: e.target.value })}
              />
            </FormGroup>
          </div>

          <div className="mb-3">
            <FormGroup label="Message" labelFor="contact-message">
              <textarea
                id="contact-message"
                required
                rows="3"
                className="form-control border-secondary"
                placeholder="Type your message details..."
                value={this.state.message}
                onChange={(e) => this.setState({ message: e.target.value })}
                style={{ color: '#182026', backgroundColor: '#fff' }}
              ></textarea>
            </FormGroup>
          </div>

          <Button
            intent={Intent.PRIMARY}
            type="submit"
            icon="envelope"
            small
            loading={this.state.loading}
            text="Send Message"
          />
        </form>
      </Card>
    );
  }
}
